module.exports = __webpack_public_path__ + "img/tc-14.4906fd41.png";